import {colors} from "@material-tailwind/react/types/generic";

export interface Advisor {
    id?: number;
    projectId?: string;
    name: string;
    email: string;
    certificate?: Certificate;
}

export interface Member {
    id?: number;
    projectId?: string;
    name: string;
    email: string;
    gender: string;
    eduProgram: number;
    certificate?: Certificate;
}

interface Certificate {
    uuid: string;
    projectId: string;
    name: string;
    email: string;
    period: string;
    projectName: string;
    category: string;
    dataHash: string;
    relatedType: string;
    safeHash: boolean;
}

export interface ProjectInfo {
    uuid: number;
    projectName: string;
    subject: string;
    locationFile: string;
    category: string;
    advisors: Advisor[];
    members: Member[];
}

export interface ProjectRegisterForm {
    projectName: string;
    projectSubject: string;
    projectFile: any;
    projectCategory: string;
    projectMembers: Member[];
    projectAdvisors: Advisor[];
}

export const CategoriesChipColors: { [key: string]: colors } =  {
    ['Base Tecnológica']: 'blue',
    ['Emprendimiento Social y Ambiental']: 'deep-orange',
    ['Emprendimiento Tradicional']: 'blue-gray'
}